import helpers from '../helpers';
import scrollDepth from 'scroll-depth';

let eventsTrigger = false;

function clearText(text) {
	return text.toString().trim().replace(/\s+/g, ' ');
}

function start15SecTimeout() {
	clearTimeout(helpers.$window.data('timeout15Sec'));

	helpers.$window.data('timeout15Sec', setTimeout(() => {
		ga('rbcspec.send', 'event', 'page', 'spent_on_page_15_sec');
		ga('send', 'event', 'page', 'spent_on_page_15_sec');
	}, 15000));
}

start15SecTimeout();

scrollDepth({
	userTiming: false,
	pixelDepth: false,
	gtmOverride: true,
	eventHandler(data) {
		ga('send', 'event', data.eventCategory, data.eventAction, data.eventLabel, {nonInteraction: false});
		ga('rbcspec.send', 'event', data.eventCategory, data.eventAction, data.eventLabel, {nonInteraction: false});
	},
});

/**
* Создать куки запись
* @param {string} path Обязательное, ссылка/путь
*/
function virtualHit(path) {
	if (window.ga) {
		ga('set', 'page', path);
		ga('send', 'pageview', path);
		// Не всегда используются
		ga('rbcspec.set', 'page', path);
		ga('rbcspec.send', 'pageview', path);
	}
}

window.isTwentyFifth = false;
window.isFifthy = false;
window.isSeventyFifth = false;
window.isOneHundred = false;

const scrollProgress = (progress) => {
	ga('send', 'event', 'Scroll Depth', 'Percentage', progress, {nonInteraction: false});
	ga('rbcspec.send', 'event', 'Scroll Depth', 'Percentage', progress, {nonInteraction: false});
};

const scrollDept = (percent) => {
	if (percent > 25 && !window.isTwentyFifth) {
		window.isTwentyFifth = true;

		scrollProgress('25%');
	} else if (percent > 50 && !window.isFifthy) {
		window.isFifthy = true;

		scrollProgress('50%');
	} else if (percent > 75 && !window.isSeventyFifth) {
		window.isSeventyFifth = true;

		scrollProgress('75%');
	} else if (percent === 100 && !window.isOneHundred) {
		window.isOneHundred = true;

		scrollProgress('100%');
	}
};

$('.header__logo--rbc').on('click.analytics', () => {
	ga('send', 'event', 'nav', 'rbc logo');
});

$('.header__logo--megafon').on('click.analytics', () => {
	ga('send', 'event', 'client link', 'logo header');
	ga('rbcspec.send', 'event', 'client link', 'click');
});

/**
 * Home page
 * Click down arrow
 * Hover on Read more
 * Click on Read more
 */

// Down arrow
const $homeIntroArrow = helpers.$document.find('.home__intro-button');
$homeIntroArrow.on('click', (e) => {
	e.preventDefault();

	ga('send', 'event', 'main', 'down button');
});

// Hover Read more

if( $(window).width() >= 768 ) {

	const $linkReadMore = helpers.$document.find('.home-link__button');
	$linkReadMore.mouseenter((event) => {
		const title = $(event.currentTarget).parent().find('.home-link__title').text();

		if( $(event.currentTarget).hasClass('wasHover') ) {

		} else {
			$(event.currentTarget).addClass('wasHover');
			// ga('send', 'event', 'main', 'material hover', title);
		}

	});
}

// Click on Read more
const $btnCaptionRead = helpers.$document.find('.home-link__caption-button');
$btnCaptionRead.on('click', (event) => {
	const title = $(event.currentTarget).parents('.home-link').find('.home-link__title').text();

	ga('send', 'event', 'main', 'material click', title);
});

$('.home-link__button-link').on('click', function () {
	const title = $(this).parents('.home-link').find('.home-link__title').text();

	// ga('send', 'event', 'main', 'material click', title);

	ga("send", "event", "main", "article point click", title);
});

// $('.home-link__title').on('click', function () {
// 	const title = $(this).text();
//
// 	ga('send', 'event', 'main', 'material click', title);
// })

$('.home-link__caption-item').on('click', function () {
	const title = $(this).text();
	const titleArticle = $(this).closest('.home-link').find('.home-link__title').text();

	ga("send", "event", "main", "inside material click", `${clearText(title)} - ${clearText(titleArticle)}`);
});


// ********************************** //

const clienLinks = ['megafon.ru'];

function isClientLink(href) {
	let value = false;

	clienLinks.forEach((link) => {
		if (href.indexOf(link) >= 0) {
			value = true;
		}
	});

	return value;
}

$('.home__text a, .cloud__text a, .cybersecurity__text a, .services__text a, .digital__text a, .cybersecurity-interview__text a, .cybersecurity-interview__btn, .iot__text a').on('click.analytics', (e) => {
	const link = e.currentTarget.href;
	const name = e.currentTarget.textContent;
	const chekClientLink = isClientLink(link);

	if (chekClientLink) {
		ga('send', 'event', 'client link', 'article text link', name);
		ga('rbcspec.send', 'event', 'client link', 'click');
	} else {
		ga('send', 'event', 'article', 'article text link', name);
	}
});

$('.card').on('click.analytics', (e) => {
	const type = $(e.currentTarget);

	ga('send', 'event', 'article', 'article middle link', clearText(type.text()));
});

$('.cloud__link').on('click.analytics', (e) => {
	const type = $(e.currentTarget);

	ga('send', 'event', 'article', 'article bottom link', clearText(type.text()));
});

$('.social__button').on('click.analytics', (e) => {
	let name = $(e.currentTarget).data('social');

	ga('send', 'event', 'share', 'article share', name);
});

$('.footer-social__item').on('click.analytics', (e) => {
	let name = $(e.currentTarget).data('social');

	ga('send', 'event', 'share', 'project share', name);
});

helpers.$document
	.on('slider-init', (_, slider) => {
		const $slider = $(slider);

		$slider.find('.slider-also__item').on('click.analytics', (e) => {
			const type = clearText($(e.currentTarget).find('.slider-also__link').text());
			const title = $(e.currentTarget).find('.slider-also__text').text();

			ga('send', 'event', 'article', 'article bottom link', `${type}: ${title}`);
		});

		$slider.find('.slider__item').on('click.analytics', (e) => {
			const type = clearText($(e.currentTarget).find('.slider__link').text());
			const title = $(e.currentTarget).find('.slider__text').text();

			ga('send', 'event', 'article', 'article top link', `${type}: ${title}`);
		});
	});

function triggersInit() {
	if (!eventsTrigger) {
		helpers.$document.on('test-start', () => {
			ga('send', 'event', 'test', 'start', {nonInteraction: true});
			ga('rbcspec.send', 'event', 'test', 'start', {nonInteraction: true});
		}).on('test-question-show', (e, stepIndex, question) => {
			ga('send', 'event', 'test', `question show ${stepIndex}`, clearText(question), {nonInteraction: true});
		}).on('test-result', (e, result, count) => {
			ga('send', 'event', 'test', 'finish', result, count);
			ga('rbcspec.send', 'event', 'test', 'finish', result);
		})
			.on('test-reload', () => {
				ga('send', 'event', 'test', 'resume');
			})
			.on('slider-change', () => {
				ga('send', 'event', 'article', 'slider change');
			})
			.on('quiz-question-show', (e, stepIndex, question) => {
				ga('send', 'event', 'article test', `question show ${stepIndex}`, clearText(question), {nonInteraction: true});
			})
			.on('quiz-result', (e, result) => {
				ga('send', 'event', 'article test', 'finish', result);
				ga('rbcspec.send', 'event', 'article test', 'finish', result);
			})
			.on('audio-play', (e, name) => {
				ga('send', 'event', 'audio', 'play', name, {nonInteraction: false});
			})
			.on('audio-end', (e, name) => {
				ga('send', 'event', 'audio', 'finish', name);
			})
			.on('audio-30-sec', (e, name) => {
				ga('send', 'event', 'audio', 'timing 30s', name, 30);
			})
			.on('video-play', (e, name) => {
				ga('send', 'event', 'video', 'play', name, {nonInteraction: true});
				ga('rbcspec.send', 'event', 'video', 'play', {nonInteraction: true});
			})
			.on('video-ended', (e, name) => {
				ga('send', 'event', 'video', 'finish', name);
				ga('rbcspec.send', 'event', 'video', 'finish');
			})
			.on('video-interval-30', (e, name) => {
				ga('send', 'event', 'video', 'timing 30s', name, 30);
				ga('rbcspec.send', 'event', 'video', 'timing 30s', '', 30);
			});
	}
}

triggersInit();

helpers.$document
	.on('slider-change', () => {
		ga('send', 'event', 'article', 'slider change');
	})
	.on('slider-init', (_, slider) => {
		const $slider = $(slider);

		$slider.find('.slider-also__item').on('click.analytics', (e) => {
			const type = clearText($(e.currentTarget).find('.slider-also__link').text());
			const title = $(e.currentTarget).find('.slider-also__text').text();

			ga('send', 'event', 'article', 'article bottom link', `${type}: ${title}`);
		});

		$slider.find('.slider__item').on('click.analytics', (e) => {
			const type = clearText($(e.currentTarget).find('.slider__link').text());
			const title = $(e.currentTarget).find('.slider__text').text();

			ga('send', 'event', 'article', 'article top link', `${type}: ${title}`);
		});
	});

export default {
	start15SecTimeout,
	virtualHit,
	scrollDept,
};
